import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-success-dialog-template',
  templateUrl: './success-dialog-template.component.html',
  styleUrls: ['./success-dialog-template.component.scss']
})
export class SuccessDialogTemplateComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
